import { render, staticRenderFns } from "./basicInfolist.vue?vue&type=template&id=647f5dae&scoped=true&slot=groupTitle&"
import script from "./basicInfolist.vue?vue&type=script&lang=js&"
export * from "./basicInfolist.vue?vue&type=script&lang=js&"
import style0 from "./basicInfolist.vue?vue&type=style&index=0&id=647f5dae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f5dae",
  null
  
)

export default component.exports